<router-outlet></router-outlet>
<ngx-spinner name="general" type="ball-scale-multiple"></ngx-spinner>
